import 'antd/dist/antd.css';
import './App.css';
import './index.css';

import {
    BarChartOutlined,
    ContactsOutlined,
    DownloadOutlined,
    HomeOutlined,
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    QuestionCircleOutlined,
    SearchOutlined,
} from '@ant-design/icons';
import { BrowserRouter, Link, Route, Switch } from 'react-router-dom';
import { Layout, Menu } from 'antd';

import Page404 from './pages/Page404';
import PageChineseDrugs from './pages/PageChineseDrugs';
import PageContact from './pages/PageContact';
import PageDisease from './pages/PageDisease';
import PageDiseaseDetail from './pages/PageDiseaseDetail';
import PageDownload from './pages/PageDownload';
import PageHelp from './pages/PageHelp';
import PageHome from './pages/PageHome';
import PageIngredient from './pages/PageIngredient';
import PageIngredientDetail from './pages/PageIngredientDetail';
import PageIngredientSimilarity from './pages/PageIngredientSimilarity';
import PagePlant from './pages/PagePlant';
import PagePlantCategoryList from './pages/PagePlantCategoryList';
import PagePlantDetail from './pages/PagePlantDetail';
import PagePlantNetwork from './pages/PagePlantNetwork';
import PageRecipe from './pages/PageRecipeSearch';
import PageRecipeDetail from './pages/PageRecipeDetail';
import PageStatistics from './pages/PageStatistics';
import PageTarget from './pages/PageTarget';
import PageTargetDetail from './pages/PagetargetDetail';
import React from 'react';
import { createBrowserHistory } from 'history';
import logo from './img/supertcm_logo_with_name.png';
import logo2 from './img/supertcm_logo.png';
import PageAnimalMineralProducts from './pages/PageAnimalMineralProducts';

const { Header, Sider, Content, Footer } = Layout;
const { SubMenu } = Menu;

const history = createBrowserHistory();

type SiderDemoPropsType = {
    history: any;
};

const routeUpdate = (path: string): any => ({
    currentRoute: path,
    menuRoute: ['/' + path.split('/')[1]],
});

type treeItemType = {
    name: string;
    key: string;
};

const menuSearchTree: treeItemType[] = [
    { name: 'Herb', key: '/plant' },
    { name: 'Recipe', key: '/recipe' },
    { name: 'Ingredient', key: '/ingredient' },
    { name: 'Target', key: '/target' },
    { name: 'Disease', key: '/disease' },
];

class SiderDemo extends React.Component<SiderDemoPropsType> {
    state = {
        collapsed: false,
        currentRoute: '',
        menuRoute: [''],
    };

    toggle = (): void => {
        this.setState({
            collapsed: !this.state.collapsed,
        });
    };

    componentDidMount(): void {
        const { history } = this.props;
        this.setState(routeUpdate(history.location.pathname));
        history.listen(() => {
            this.setState(routeUpdate(history.location.pathname));
        });
    }

    render(): JSX.Element {
        const { menuRoute, collapsed } = this.state;

        return (
            <Layout style={{ minHeight: '100vh' }}>
                <Sider collapsible collapsed={collapsed} onCollapse={this.toggle}>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        {collapsed ? (
                            <img
                                src={logo2}
                                alt="SuperTCM"
                                style={{ width: '60px', height: '60px', marginTop: '10px', marginBottom: '5px' }}
                            />
                        ) : (
                            <img src={logo} alt="SuperTCM" style={{ width: '180px', height: '120px' }} />
                        )}
                    </div>
                    <Menu theme="dark" mode="inline" defaultSelectedKeys={['1']} selectedKeys={menuRoute}>
                        <Menu.Item key="/home" icon={<HomeOutlined />}>
                            <Link to="/home">Home</Link>
                        </Menu.Item>
                        <SubMenu icon={<SearchOutlined />} key="2" title={<span>Search</span>}>
                            {menuSearchTree.map((e) => (
                                <Menu.Item key={e.key}>
                                    <Link to={e.key}>{e.name}</Link>
                                </Menu.Item>
                            ))}
                        </SubMenu>
                        {/* <Menu.Item key="/download" icon={<DownloadOutlined />}>
                            <Link to="/download">Download</Link>
                        </Menu.Item> */}
                        <Menu.Item key="/help" icon={<QuestionCircleOutlined />}>
                            <Link to="/help">Help/FAQ</Link>
                        </Menu.Item>
                        <Menu.Item key="/statistics" icon={<BarChartOutlined />}>
                            <Link to="/statistics">Statistics</Link>
                        </Menu.Item>
                        <Menu.Item key="/contact" icon={<ContactsOutlined />}>
                            <Link to="/contact">Contact</Link>
                        </Menu.Item>
                    </Menu>
                </Sider>
                <Layout className="site-layout">
                    <Header style={{ paddingLeft: '1.2em', backgroundColor: 'white' }}>
                        {React.createElement(this.state.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
                            className: 'trigger',
                            style: { fontSize: '1.2em', cursor: 'pointer' },
                            onClick: this.toggle,
                        })}
                    </Header>
                    <Content
                        style={{
                            margin: '24px 16px',
                            padding: 24,
                            minHeight: 280,
                            backgroundColor: 'white',
                        }}
                    >
                        {this.props.children}
                    </Content>
                    <Footer style={{ textAlign: 'center', paddingTop: '0' }}>
                        SuperTCM V2.0 ©
                        <a
                            href="http://bioinf-apache.charite.de/main/index.php"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Structural Bioinformatics Group
                        </a>{' '}
                        2020
                    </Footer>
                </Layout>
            </Layout>
        );
    }
}

const App: React.FC = () => (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
        <SiderDemo history={history}>
            <Switch>
                <Route path="/home">
                    <PageHome />
                </Route>
                <Route path="/plant/network/:table/:column/:name/:bid">
                    <PagePlantNetwork />
                </Route>
                <Route path="/plant/detail/:name">
                    <PagePlantDetail />
                </Route>
                <Route path="/plant/herb/:name">
                    <PageChineseDrugs />
                </Route>
                <Route path="/plant/list/:category/:keyword">
                    <PagePlantCategoryList />
                </Route>
                <Route path="/plant">
                    <PagePlant />
                </Route>
                <Route path="/recipe/detail/:name/:rid">
                    <PageRecipeDetail />
                </Route>
                <Route path="/recipe">
                    <PageRecipe />
                </Route>
                <Route path="/ingredient/similarity">
                    <PageIngredientSimilarity />
                </Route>
                <Route path="/ingredient/detail/:iid">
                    <PageIngredientDetail />
                </Route>
                <Route path="/ingredient">
                    <PageIngredient />
                </Route>
                <Route path="/target/:name">
                    <PageTargetDetail />
                </Route>
                <Route path="/target">
                    <PageTarget />
                </Route>
                <Route path="/disease/detail/:id">
                    <PageDiseaseDetail />
                </Route>
                <Route path="/disease">
                    <PageDisease />
                </Route>
                {/* <Route path="/download">
                    <PageDownload />
                </Route> */}
                <Route path="/help">
                    <PageHelp />
                </Route>
                <Route path="/statistics">
                    <PageStatistics />
                </Route>
                <Route path="/contact">
                    <PageContact />
                </Route>
                <Route path="/animal/:tcm_types">
                    <PageAnimalMineralProducts />
                </Route>
                <Route path="/">
                    <PageHome />
                </Route>
                <Route path="*">
                    <Page404 />
                </Route>
            </Switch>
        </SiderDemo>
    </BrowserRouter>
);

export default App;
